var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClipboardSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8555 3.57861H14.8555C15.3859 3.57861 15.8946 3.78933 16.2697 4.1644C16.6448 4.53947 16.8555 5.04818 16.8555 5.57861V19.5786C16.8555 20.109 16.6448 20.6178 16.2697 20.9928C15.8946 21.3679 15.3859 21.5786 14.8555 21.5786H2.85547C2.32504 21.5786 1.81633 21.3679 1.44126 20.9928C1.06618 20.6178 0.855469 20.109 0.855469 19.5786V5.57861C0.855469 5.04818 1.06618 4.53947 1.44126 4.1644C1.81633 3.78933 2.32504 3.57861 2.85547 3.57861H4.85547",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8555 1.57861H5.85547C5.30318 1.57861 4.85547 2.02633 4.85547 2.57861V4.57861C4.85547 5.1309 5.30318 5.57861 5.85547 5.57861H11.8555C12.4078 5.57861 12.8555 5.1309 12.8555 4.57861V2.57861C12.8555 2.02633 12.4078 1.57861 11.8555 1.57861Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardSvg);
export default __webpack_public_path__ + "static/media/ClipboardSVG.8fded0d50b71611d56f2aeb3e466763c.svg";
export { ForwardRef as ReactComponent };